export const getActualDate = () => {
  const date = new Date();

  return [
    date.getFullYear(),
    `0${date.getMonth() + 1}`.slice(-2),
    `0${date.getDate()}`.slice(-2),
  ].join('-');
};

export const timeToText = (time: string) => {
  const VALID_TIME = /[0-9]{2}:[0-9]{2}:[0-9]{2}/;

  if (!VALID_TIME.test(time)) {
    return '';
  }

  const parsedTime = time?.split(':');

  return parsedTime.reduce((prev, curr, index) => {
    let timeUnitToSet: string;
    if (Number(curr) > 0) {
      if (index === 0) {
        timeUnitToSet = 'hr';
      }

      if (index === 1) {
        timeUnitToSet = 'min';
      }

      if (index === 2) {
        timeUnitToSet = 'sec';
      }

      return `${prev}${prev === '' ? '' : ' '}${Number(curr)} ${timeUnitToSet}`;
    }

    return prev;
  }, '');
};

export const secondsToText = (seconds: number) => {
  const hoursStart = Math.floor(seconds / 3600);
  const minStart = (seconds - hoursStart * 3600) / 60;

  return `${hoursStart.toString().padStart(2, '0')} hrs, ${minStart
    .toString()
    .padStart(2, '0')} min`;
};

export const toLocalISOString = (date: Date) => {
  const locale = date.toLocaleDateString().split('/');
  const day = locale?.[0].padStart(2, '0');
  const month = locale?.[1].padStart(2, '0');
  const year = locale?.[2];
  const newDate = new Date(`${month}-${day}-${year} 00:00:00.000Z`);

  return newDate.toISOString();
};
